
<template>
  <div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'UserEquity'
    ])
  },
  created () {

  },
  methods: {
    emitDurationLimit() {
      let type = 'save';
      let timeAll = this.TOOL.getDuration();
      if (this.UserEquity.time && timeAll > this.UserEquity.time) {
        type = 'danger';
      } else if (this.UserEquity.time && timeAll >= this.UserEquity.time - 10000) {
        type = 'warning';
      }
      eve("totalTime_danger", null, { timeAll: timeAll, type });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/tool/timeline/limitMixin.vue